<template>
  <div
    class="rr-metric"
    :class="{
      'rr-metric_disabled': disabled,
    }"
  >
    <div
        class="rr-metric__soon"
        v-if="soon"
        v-html="soonText"
    ></div>
    <div class="rr-metric__icon" v-if="icon">
      <Icon :name="icon" size="xxl"></Icon>
    </div>
    <div class="rr-metric__title">
      <Icon class="rr-metric__title-icon" v-if="valueIcon" :name="valueIcon" size="xl"></Icon>
      <div class="rr-metric__title-text">
        <span class="rr-metric__value" v-html="value"></span><span class="rr-metric__units" v-if="units" v-html="units"></span>
      </div>
    </div>
    <div class="rr-metric__subtitle" v-if="$slots.subtitle">
      <slot name="subtitle"></slot>
    </div>
    <div class="rr-metric__subtitle" v-else-if="subtitle" v-html="subtitle"></div>
  </div>
</template>

<script>
import Icon from '@rr-component-library/icon/src/main';

export default {
  name: 'Metric',
  designVersion: '1.0.1',
  components: {
    Icon,
  },
  props: {
    icon: String,
    value: String,
    units: String,
    subtitle: String,
    valueIcon: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    soon: {
      type: Boolean,
      default: false,
    },
    soonText: {
      type: String,
      default: 'Скоро',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Metric";
</style>
